/*global google*/
import React from 'react';
import { useState } from 'react';
import axios from 'axios';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import SideBar from './SideBar';

const containerStyle = {
    width: '100%',
    height: '95vh'
};

const center = {
    lat: 21.977434,
    lng: 78.283474
};

function MyComponent() {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
      googleMapsApiKey : "AIzaSyAr-n9zN3vYDBaPtINPgPQi70DGtHUiyfE"
       
    })
    const [map, setMap] = useState(null)
    const onLoad = React.useCallback(function callback(map) {
        function firstFunction1() {
            return new Promise((resolve, reject) => {
                const y =  axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Inspection/inspectionDetails/getInspectionDetailsList`, { "createdBy" : sessionStorage.getItem("userCode")})
                resolve(y)
                
            })
        }
        async function secondFunction1() {
            const result = await firstFunction1()
            var response_value = JSON.stringify(result.data.dataContent)
         
            let mylocalvalue = JSON.parse(response_value);
            console.log("mylocalvalue", mylocalvalue)
            var myFinalArray = [];
            var myInfoWindow = [];
            var myPolygon;
            var myPolygon = [];
            var myMarker =[]
            var infowindow = []
           
          
            for (let i = 0; i < mylocalvalue.length; i++) {

                 infowindow[i] = new google.maps.InfoWindow({
                    // content: "<strong>Scheme : </strong>" + mylocalvalue[i].schemeName
                    content : `<div id="infoContent"> <span> <strong><b>Field Inspection - </b></strong> </span></br> <span><strong>Scheme : </strong></span><span>${mylocalvalue[i].schemeName}</span></br><span><strong>State : </strong></span><span>${mylocalvalue[i].stateName}</span></br><span><strong>District : </strong></span><span>${mylocalvalue[i].districtName}</span></br><span><strong>Sub District : </strong></span><span>${mylocalvalue[i].subDistrictName}</span></br><span><strong>Village : </strong></span><span>${mylocalvalue[i].villageName}</span></br><span><strong>Inspection Code : </strong></span><span>${mylocalvalue[i].inspectionCode}</span></br><span><strong>Inspection Date & Time: </strong></span><span>${mylocalvalue[i].createdOn.split("T")[0] + " " + mylocalvalue[i].createdOn.split("T")[1].slice(0, 5)}</span></div>`
                  });

                  myMarker[i] = new google.maps.Marker({
                    position: {lat: Number(mylocalvalue[i].inspectionImgList[0].surveyorLat), lng: Number(mylocalvalue[i].inspectionImgList[0].surveyorLong) },
                    map: map,
                    // title: "Click to zoom",
                  })
               
                // myMarker[i] =  new google.maps.Marker({
                //     position: myPolygon[i].my_getBounds().getCenter(),
                //     map: map,
                //     title: "Click to zoom",

                //   })

                  myMarker[i].addListener("click", () => {
                    map.panTo(myMarker[i].getPosition());
                    map.setZoom(18);
                  });

                  google.maps.event.addListener(myMarker[i], 'mouseover', function() {
                    //  document.getElementsByClassName("gm-style-iw").nextElementSibling.style.display = "none"
                    infowindow[i].open(map,myMarker[i]);
                  });

                  google.maps.event.addListener(myMarker[i], 'mouseout', function() {
                    infowindow[i].close();
                  });

               
            }  
        };
        secondFunction1()
    }, [])

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    return isLoaded ? (
        <>
          <SideBar/>
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={5.3}
                onLoad={onLoad}
                onUnmount={onUnmount}
                mapTypeId= "satellite"
               
                >
                <></>
            </GoogleMap>
            
        </>
    ) : <></>
}

export default React.memo(MyComponent)



// LatLngBounds boundsIndia = new LatLngBounds(new LatLng(23.63936, 68.14712), new LatLng(28.20453, 97.34466));
// int padding = 0; // offset from edges of the map in pixels
// CameraUpdate cameraUpdate = CameraUpdateFactory.newLatLngBounds(boundsIndia, padding);
//  mMap.animateCamera(cameraUpdate);